import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import LOAForm from "./LOAForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getGovtRequest,
  getRequestTypes,
  updateGovtRequest,
} from "common/services/govt-requests.service";
import { useNavigate, useParams } from "react-router-dom";
import { extractFieldErrors } from "common/lib/fieldErrors";
import { normalize } from "common/lib/normalize";

const UpdateLOA = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  const navigate = useNavigate();

  const { id: requestId } = useParams();
  const [requestData, setRequestData] = useState<any>({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getGovtRequest(requestId, {
          populate: [
            "agency",
            "mda",
            "mda.region",
            "paymentCategory",
            "positionType",
            "typeOfRequest",
            "createdby",
            "updatedby",
            "positionType",
            "documentAttachments",
            "formOfGovernmentRequest",
          ],
        });
        setRequestData(normalize(response.data));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [requestId]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      requestTitle: requestData?.requestTitle || "",
      noOfPositionsRequested: requestData?.noOfPositionsRequested || "",
      positionTitle: requestData?.positionTitle || "",
      requestedSalary: requestData?.requestedSalary || null,
      totalValueOfRequest: requestData?.totalValueOfRequest || null,
      periodInMonths: requestData?.periodInMonths || "",
      dateOfRequest:
        (requestData?.dateOfRequest && new Date(requestData?.dateOfRequest)) ||
        "",
      startDate:
        (requestData?.startDate && new Date(requestData.startDate)) || "",
      endDate: (requestData?.endDate && new Date(requestData.endDate)) || "",
      documentAttachments: [],
      fundingStatus: requestData?.fundingStatus || "",
      reviewOfRequest: requestData?.reviewOfRequest || "",
      agency: {
        value: requestData?.agency?.id || "",
        label: requestData?.agency?.name || "",
      },
      region: {
        value: requestData?.mda?.region?.id || "",
        label: requestData?.mda?.region?.name || "",
      },
      mda: {
        value: requestData?.mda?.id || "",
        label: requestData?.mda?.name || "",
      },
      additionalDetails: requestData?.additionalDetails || "",
      selectedFiles:
        (requestData?.documentAttachments &&
          requestData?.documentAttachments?.map((file: any) => {
            return {
              id: file.id,
              name: file.name,
              formattedSize: file.size + " KB",
            };
          })) ||
        [],
    },
    validationSchema: Yup.object({
      requestTitle: Yup.string().required("Please enter request title"),
      noOfPositionsRequested: Yup.number(),
      positionTitle: Yup.string(),

      requestedSalary: Yup.number().nullable(),
      totalValueOfRequest: Yup.number().required("Please enter total value"),
      periodInMonths: Yup.number().nullable(),
      startDate: Yup.date().nullable(),

      endDate: Yup.date().nullable(),
      dateOfRequest: Yup.date().nullable(),
      fundingStatus: Yup.string(),
      reviewOfRequest: Yup.string(),
      agency: Yup.object().shape({
        value: Yup.string().required("Please select agency"),
      }),
      region: Yup.object().shape({
        value: Yup.string().required("Please select region"),
      }),
      mda: Yup.object().shape({
        value: Yup.string().required("Please select MDA"),
      }),

      additionalDetails: Yup.string(),
      selectedFiles: Yup.array(),
      // .min(1, "Atleast one file is required")
      // .required("Required"),
    }),
    onSubmit: async (values: any) => {
      try {
        let data = {};
        const requestTypeResponse = await getRequestTypes({
          filters: {
            code: "Other",
          },
        });
        const requestTypeId = requestTypeResponse?.data[0];

        data = {
          requestTitle: values?.requestTitle || null,
          typeOfRequest: requestTypeId || null,
          requestDescription: values?.requestDescription || null,
          noOfPositionsRequested: `${values?.noOfPositionsRequested}` || null,
          positionTitle: values?.positionTitle || null,
          requestedSalary: values?.requestedSalary || null,
          totalValueOfRequest: values?.totalValueOfRequest || null,
          periodInMonths: values?.periodInMonths?.toString() || null,
          dateOfRequest:
            (values?.dateOfRequest &&
              values?.dateOfRequest?.toLocaleDateString("en-CA")) ||
            null,
          startDate:
            (values?.startDate &&
              values.startDate?.toLocaleDateString("en-CA")) ||
            null,
          endDate:
            (values?.endDate && values?.endDate?.toLocaleDateString("en-CA")) ||
            null,
          contactPerson: null,
          fundingStatus: values?.fundingStatus || null,
          reviewOfRequest: values?.reviewOfRequest || null,
          agency: values?.agency?.value || null,
          region: values?.region?.value || null,
          mda: values?.mda?.value || null,
          entity: values?.entity?.label || null,
          positionType: values?.positionType?.value || null,
          formOfGovernmentRequest: null,
          nameOfRequester: null,
          objectiveOfRequest: null,
          expectedOutputs: null,
          additionalDetails: values?.additionalDetails || null,
          isLOA: true,
        };

        const formData = new FormData();

        values.selectedFiles.forEach((file: any) => {
          if (!file?.id) {
            formData.append("files.documentAttachments", file, file.name);
          }
        });
        formData.append("data", JSON.stringify(data));

        setLoading(true);
        await updateGovtRequest(requestId, formData);
        // navigate("/government-requests/" + requestId);
        navigate("/loas");
      } catch (error: any) {
        const errors = extractFieldErrors(error?.response);
        setFieldErrors(errors);
      } finally {
        setLoading(false);
      }
    },
  });

  console.log("Validation errors:", validation.errors);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Update LOA"
          pageTitles={[
            {
              title: "Dashboard",
              link: "/",
            },
            { title: "LOAs", link: "/loas" },
          ]}
          back
        />
        <LOAForm
          validation={validation}
          isUpdate={false}
          loading={loading}
          fieldErrors={fieldErrors}
        />
      </Container>
    </div>
  );
};

export default UpdateLOA;
